(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-custom"] && !Shopify.designMode) return;
  try {
    

/**
 * <kiksy-anbar-rotator>
 * Custom element — progressively enhanced announcement rotator.
 *
 * Responsibilities:
 *   - Rotates .kiksy-anbar__slide children at data-speed ms intervals
 *   - Handles prev / next arrow buttons
 *   - Respects prefers-reduced-motion (disabled if user prefers)
 *   - Pauses on hover/focus (prevents accidental navigation)
 *   - Cleans up the interval on disconnect (no memory leaks)
 *   - Zero external dependencies — analytics/pixel safe
 */

if (!customElements.get('kiksy-anbar-rotator')) {
  class KiksyAnBarRotator extends HTMLElement {
    connectedCallback() {
      this._slides  = Array.from(this.querySelectorAll('.kiksy-anbar__slide'));
      this._current = 0;
      this._timer   = null;

      // Bail if only 1 (or 0) slides — nothing to rotate
      if (this._slides.length <= 1) return;

      // Respect user preference for reduced motion
      const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mq.matches) return;

      this._speed = parseInt(this.dataset.speed, 10) || 3000;

      this._bindArrows();
      this._bindPause();
      this._start();
    }

    disconnectedCallback() {
      this._stop();
    }

    /* ── Private ─────────────────────────────────── */

    _bindArrows() {
      const prev = this.querySelector('.kiksy-anbar__arrow--prev');
      const next = this.querySelector('.kiksy-anbar__arrow--next');

      if (prev) prev.addEventListener('click', () => {
        this._stop(); this._advance(-1); this._start();
      });
      if (next) next.addEventListener('click', () => {
        this._stop(); this._advance(1); this._start();
      });
    }

    _bindPause() {
      // Pause auto-rotation when user hovers or focuses the bar
      this.addEventListener('mouseenter', () => this._stop());
      this.addEventListener('mouseleave', () => this._start());
      this.addEventListener('focusin',    () => this._stop());
      this.addEventListener('focusout',   () => this._start());
    }

    _start() {
      if (this._timer) return; // already running
      this._timer = setInterval(() => this._advance(1), this._speed);
    }

    _stop() {
      clearInterval(this._timer);
      this._timer = null;
    }

    _advance(dir) {
      const prev = this._current;
      this._current = (this._current + dir + this._slides.length) % this._slides.length;

      // Hide previous slide
      this._slides[prev].classList.remove('is-active');
      this._slides[prev].setAttribute('aria-hidden', 'true');
      if (this._slides[prev].tagName === 'A') {
        this._slides[prev].setAttribute('tabindex', '-1');
      }

      // Show next slide
      this._slides[this._current].classList.add('is-active');
      this._slides[this._current].removeAttribute('aria-hidden');
      if (this._slides[this._current].tagName === 'A') {
        this._slides[this._current].removeAttribute('tabindex');
      }
    }
  }

  customElements.define('kiksy-anbar-rotator', KiksyAnBarRotator);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-custom"] && !Shopify.designMode) return;
  try {
    
class KiksyFaq extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('details').forEach(el => {
      const summary = el.querySelector('summary');
      const body    = el.querySelector('.kiksy-faq__body');
      if (!summary || !body) return;

      summary.addEventListener('click', e => {
        e.preventDefault();
        el.open ? this._close(el, body) : this._open(el, body);
      });
    });
  }

  _open(el, body) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.open = true;
      return;
    }
    el.open = true;
    const h = body.scrollHeight;
    body.style.overflow = 'hidden';
    body.style.height   = '0px';
    body.getBoundingClientRect(); // force reflow
    body.style.transition = 'height 0.28s ease';
    body.style.height     = h + 'px';
    body.addEventListener('transitionend', () => { body.style.cssText = ''; }, { once: true });
  }

  _close(el, body) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.open = false;
      return;
    }
    /* Add class BEFORE setting open=false so CSS keeps content visible */
    el.classList.add('kiksy-faq__item--closing');
    el.open = false; // aria-expanded is now false — correct for a11y
    body.style.overflow = 'hidden';
    body.style.height   = body.scrollHeight + 'px';
    body.getBoundingClientRect(); // force reflow
    body.style.transition = 'height 0.22s ease';
    body.style.height     = '0px';
    body.addEventListener('transitionend', () => {
      el.classList.remove('kiksy-faq__item--closing');
      body.style.cssText = '';
    }, { once: true });
  }
}

if (!customElements.get('kiksy-faq')) {
  customElements.define('kiksy-faq', KiksyFaq);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page-custom"] && !Shopify.designMode) return;
  try {
    

/**
 * <kiksy-faqp>
 * Прогресивно подобрен акордеон за FAQ секцията.
 * Анимира отварянето/затварянето по височина.
 * Уважава prefers-reduced-motion.
 */
class KiksyFaqPage extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.kiksy-faqp__item').forEach((el) => {
      const summary = el.querySelector('.kiksy-faqp__question');
      const body    = el.querySelector('.kiksy-faqp__body');
      if (!summary || !body) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();
        el.open ? this._close(el, body) : this._open(el, body);
      });
    });
  }

  _reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  _open(el, body) {
    if (this._reduced()) { el.open = true; return; }

    el.open = true;
    const h = body.scrollHeight;
    body.style.overflow   = 'hidden';
    body.style.height     = '0px';
    body.getBoundingClientRect(); // force reflow
    body.style.transition = 'height 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
    body.style.height     = h + 'px';
    body.addEventListener('transitionend', () => {
      body.style.cssText = '';
    }, { once: true });
  }

  _close(el, body) {
    if (this._reduced()) { el.open = false; return; }

    el.classList.add('kiksy-faqp__item--closing');
    el.open = false; // updates aria-expanded correctly

    body.style.overflow   = 'hidden';
    body.style.height     = body.scrollHeight + 'px';
    body.getBoundingClientRect(); // force reflow
    body.style.transition = 'height 0.24s cubic-bezier(0.4, 0, 0.2, 1)';
    body.style.height     = '0px';

    body.addEventListener('transitionend', () => {
      el.classList.remove('kiksy-faqp__item--closing');
      body.style.cssText = '';
    }, { once: true });
  }
}

if (!customElements.get('kiksy-faqp')) {
  customElements.define('kiksy-faqp', KiksyFaqPage);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-custom"] && !Shopify.designMode) return;
  try {
    
/* Mobile nav accordion — remove `open` on mobile, use native <details> toggle */
(function () {
  var mql = window.matchMedia('(max-width: 749px)');
  var selector = '.kiksy-footer__nav-details';

  function sync() {
    document.querySelectorAll(selector).forEach(function (d) {
      if (mql.matches) {
        d.removeAttribute('open');
      } else {
        d.setAttribute('open', '');
      }
    });
  }

  sync();
  mql.addEventListener('change', sync);

  /* Remove the mql listener when this section instance is unloaded in the
     theme editor, preventing duplicate listeners from accumulating across
     settings-change re-renders. On the live store this handler fires once
     on page unload (navigation) and is a no-op. */
  document.addEventListener('shopify:section:unload', function cleanup(e) {
    if (e.target && e.target.querySelector(selector)) {
      mql.removeEventListener('change', sync);
      document.removeEventListener('shopify:section:unload', cleanup);
    }
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom"] && !Shopify.designMode) return;
  try {
    
/* ── Scroll shadow via IntersectionObserver ── */
(function () {
  var header   = document.querySelector('.kiksy-header');
  var sentinel = document.querySelector('.kiksy-header__sentinel');
  if (!header || !sentinel || !window.IntersectionObserver) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      header.classList.toggle('kiksy-header--scrolled', !entry.isIntersecting);
    });
  }, { threshold: 0 });

  io.observe(sentinel);
}());

/* ── Mobile menu custom element ─────────────── */
if (!customElements.get('kiksy-mobile-menu')) {
  customElements.define('kiksy-mobile-menu', class extends HTMLElement {
    connectedCallback() {
      this._trigger  = document.querySelector('.kiksy-header__hamburger');
      this._overlay  = this.querySelector('.kiksy-header__drawer-overlay');
      this._closeBtn = this.querySelector('.kiksy-header__drawer-close');
      this._drawer   = this.querySelector('.kiksy-header__drawer');

      if (this._trigger)  this._trigger.addEventListener('click',  () => this.open());
      if (this._closeBtn) this._closeBtn.addEventListener('click', () => this.close());
      if (this._overlay)  this._overlay.addEventListener('click',  () => this.close());

      this._keydownHandler = (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) this.close();
      };
      document.addEventListener('keydown', this._keydownHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._keydownHandler);
    }

    open() {
      this.setAttribute('open', '');
      if (this._trigger) this._trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (this._closeBtn) this._closeBtn.focus();
      this._bindFocusTrap();
    }

    close() {
      this.removeAttribute('open');
      if (this._trigger) {
        this._trigger.setAttribute('aria-expanded', 'false');
        this._trigger.focus();
      }
      document.body.style.overflow = '';
    }

    _bindFocusTrap() {
      if (!this._drawer) return;
      var focusable = Array.from(
        this._drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last  = focusable[focusable.length - 1];
      this._trapHandler = function (e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
        }
      };
      this._drawer.addEventListener('keydown', this._trapHandler);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kiksy-campaign-custom"] && !Shopify.designMode) return;
  try {
    
class KiksyCountdown extends HTMLElement {
  connectedCallback() {
    const target = new Date(this.dataset.target).getTime();
    if (isNaN(target)) return;

    const pad = n => String(Math.floor(n)).padStart(2, '0');

    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        this.classList.remove('kiksy-seasonal__countdown--live');
        clearInterval(this._iv);
        return;
      }
      this.querySelector('[data-days]').textContent    = pad(diff / 86400000);
      this.querySelector('[data-hours]').textContent   = pad((diff % 86400000) / 3600000);
      this.querySelector('[data-minutes]').textContent = pad((diff % 3600000) / 60000);
      this.querySelector('[data-seconds]').textContent = pad((diff % 60000) / 1000);
      this.classList.add('kiksy-seasonal__countdown--live');
    };

    tick();
    this._iv = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this._iv);
  }
}

if (!customElements.get('kiksy-countdown')) {
  customElements.define('kiksy-countdown', KiksyCountdown);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
